import React from 'react';
import { LuMoveRight } from 'react-icons/lu';
import Partners from '../partners/Partners';
import Footer from '../../components/Footer';
import isomo from '../../assets/isomo.png';
import opportunities_uwc from '../../assets/opportunities_uwc.png';
import opportunities_ala from '../../assets/opportunities_ala.png';
import opportunities_cornerstone from '../../assets/opportunities_cornerstone.png';
import opportunities_mastercard from '../../assets/opportunities_mastercard.png';
import opportunities_rca from '../../assets/opportunities_rca.png';

import meto from '../../assets/meto.png';
import yyas from '../../assets/yyas.png';

const opportunityArray = [
  {
    id: 1,
    image: meto,
    date: 'Oct 17, 2025',
    title: 'Mētō Platform',
    paragraphs: [
      {
        text: 'Mētō is a powerful platform that connects African students to top universities worldwide. It helps you explore scholarships, prepare your application, and receive mentorship from experts who guide you through every step of your academic journey.',
      },
      {
        header: 'Who Can Apply:',
      },
      {
        text: 'High school graduates or students who are in their final high school year looking to study abroad.',
      },

      {
        header: 'Why to apply?',
      },
      {
        text: 'Get personalized university and scholarship matches.\nAccess expert application guidance.\nJoin a vibrant community of ambitious African students.',
      },
      {
        text: 'Apply here:',
        linkObj: {
          new_line: false,
          link: 'https://meto-intl.org',
        },
      },
    ],
  },

  {
    id: 2,
    image: yyas,
    date: 'Oct 17, 2025',
    title: 'Yale Young African Scholars (YYAS)',
    paragraphs: [
      {
        text: 'YYAS is an academic and leadership program for secondary school students in Africa, organized by Yale University. The program helps students strengthen their university applications, improve academic skills, and connect with peers across the continent. ',
      },
      {
        header: 'Who Can Apply:',
      },
      {
        text: 'Students aged 14–18, currently enrolled in secondary school (S4 and S5) and residing in an African country.',
      },

      {
        header: 'Why to apply?',
      },
      {
        text: 'Experience world-class learning and leadership development.\nReceive mentorship and university guidance.\nJoin a strong alumni network of African changemakers.',
      },
      {
        text: 'Apply here:',
        linkObj: {
          new_line: false,
          link: 'https://africanscholars.yale.edu/',
        },
      },
    ],
  },
  {
    id: 3,
    image: opportunities_uwc,
    date: 'Jun 27, 2025',
    title: 'United World College',
    paragraphs: [
      {
        text: 'UWC (United World Colleges) is a global network of 18+ schools and colleges that offer selected students a chance to study the International Baccalaureate (IB) in inspiring international communities. This is one of the most competitive and respected opportunities out there for high school students.',
      },
      {
        header: 'Who it\u2019s for?',
      },
      {
        text: 'Students aged 15–17 who are curious, responsible, and ready to take on the world. UWC looks for people who care about others, are open-minded, and show leadership and resilience.',
      },

      {
        header: 'What\u2019s great about it',
      },
      {
        text: 'Around 80% of students get financial aid, you study with students from all over the world, UWC helps you get into top global universities, among others',
      },

      {
        header: 'Application info: ',
      },
      {
        text: 'Applications usually open in October for the following school year. You apply through your country\u2019s UWC National Committee. ',
        linkObj: {
          new_line: true,
          link: 'https://www.uwc.org/selectioncriteria',
        },
      },
    ],
  },

  {
    id: 4,
    image: opportunities_ala,
    date: 'Jun 27, 2025',
    title: 'ALA African Leadership Academy (South Africa)',
    paragraphs: [
      {
        text: 'ALA is more than a school — it\u2019s a launchpad for Africa\u2019s future leaders. Based in South Africa, it brings together outstanding young people from across the continent for a two-year program focused on leadership, entrepreneurship, and academics.',
      },
      {
        header: 'Who it\u2019s for?',
      },
      {
        text: 'Young people under 20 years old who dream of changing the world and have the courage to make it happen.',
      },

      {
        header: 'Why you should apply',
      },
      {
        text: '97% of students receive financial aid, ALA alumni go on to top universities and lead amazing initiative, you’ll build a lifelong network of African change makers, and others. ',
      },

      {
        header: 'Application info: ',
      },
      {
        text: 'Applications usually open in July for the next academic year. You can also nominate someone amazing — ALA will contact them',
        linkObj: {
          new_line: true,
          link: 'https://www.africanleadershipacademy.org/apply/',
        },
      },
    ],
  },
  {
    id: 5,
    image: opportunities_cornerstone,
    date: 'Jun 27, 2025',
    title: 'Cornerstone Leadership Academy (CLA)',
    paragraphs: [
      {
        text: 'Cornerstone Leadership Academy is a highly respected residential high school program designed to develop young servant leaders of strong character, purpose, and vision. The academy places a strong emphasis on leadership, ethics, and spiritual growth, alongside academic excellence.',
      },
      {
        header: 'Who can apply?',
      },
      {
        text: 'Students typically in Senior 3 or Senior 4, aged around 15–17, who show, Strong leadership potential and integrity, Academic ability and willingness to serve others, A clear sense of purpose and personal responsibility',
      },

      {
        header: 'Why it matters?',
      },
      {
        text: 'CLA alumni go on to become impactful leaders in their communities, with many earning scholarships to study at top universities across Africa and beyond. The academy covers tuition, accommodation, and provides holistic development.',
      },

      {
        header: 'When to apply',
      },
      {
        text: 'Application periods may vary slightly by country, but usually open once a year. Be sure to follow updates from CLA Rwanda or your local country office.',
        linkObj: {
          new_line: true,
          link: 'https://cornerstoneschoolsafrica.org/CLA_Rwanda.html',
        },
      },
    ],
  },
  {
    id: 6,
    image: opportunities_rca,
    date: 'Jun 27, 2025',
    title: 'Rwanda Coding Academy (RCA)',
    paragraphs: [
      {
        text: 'Rwanda Coding Academy is a government-backed, elite technical school offering a three-year advanced secondary education focused on software engineering, embedded systems, and cybersecurity.',
      },
      {
        header: 'Who can apply?',
      },
      {
        text: 'Students who have completed Ordinary Level (Senior 3) and selected Rwanda Coding Academy on the forms provided by the Rwanda Education Board are eligible for selection, based on their total score in the National Examination for Ordinary Level Leavers, particularly those who performed well in Mathematics, Physics, and English.',
      },

      {
        header: 'When to apply?',
      },
      {
        text: 'Rwanda Coding Academy is one of the schools that students completing Ordinary Level can choose from. After the publication of the National Examination Results, the Rwanda Education Board selects students who both chose Rwanda Coding Academy and meet the qualification criteria.',
      },
    ],
  },
  {
    id: 7,
    image: opportunities_mastercard,
    date: 'Jun 27, 2025',
    title: 'Mastercard Foundation Scholars Program',
    paragraphs: [
      {
        text: 'The Mastercard Foundation Scholars Program offers full scholarships to bright young Africans who aspire to make a difference. Beyond financial support, it provides mentorship, leadership training, and career guidance to help you succeed.',
      },
      {
        header: 'Who can apply?',
      },
      {
        text: 'Students with strong academic records, Individuals passionate about leading change in their communities, young people facing financial challenges, especially women, refugees, and those with disabilities.',
      },

      {
        header: 'Why apply?',
      },
      {
        text: 'Covers tuition, living expenses, books, and more, access to programs that build your leadership skills and join a community of Scholars from across Africa and beyond.',
      },

      {
        header: 'How to get started',
      },
      {
        text: '1. You first have to secure admission in one among the Universities that partners with Mastercard',
      },

      {
        text: '2. Choose the institution that fits your aspirations.',
      },
      {
        text: <>3. Apply directly through the institution&rsquo;s website.</>,
      },
      {
        text: '4. Explore the list of partner institutions here:',
        linkObj: {
          new_line: true,
          link: 'https://mastercardfdn.org/en/what-we-do/our-programs/mastercard-foundation-scholars-program/where-to-apply/',
        },
      },
    ],
  },
  {
    id: 8,
    image: isomo,
    date: 'Feb 16, 2024',
    title: 'Isomo Academy 2024',
    paragraphs: [
      {
        text: 'Applications open from December 18, 2023 to April 22, 2024For more details and application go to Bridge2 Rwanda or use the following link: ',
        linkObj: {
          new_line: true,
          link: 'https://www.bridge2rwanda.org/isomo-academy/isomo-application/',
        },
      },

      {
        text: 'Isomo Academy 2024 Application',
      },
      {
        text: 'The following information will help you understand our program better before submitting your application. Please read carefully.',
      },
      {
        text: 'The program will help students develop foundational English language skills in reading, writing, listening, and speaking, and broaden their worldview through readings that sharpen their critical thinking and engage all areas of their personal growth to enhance their leadership skills.',
      },
      {
        text: "Isomo Academy is designed to help Rwanda's top high school students with the skills they need to compete and win university scholarships inside and outside Rwanda.",
      },
      {
        text: 'Applicants must be in S4 to be eligible.',
      },
      {
        text: 'This is a 8-week, residential program beginning in mid-July to mid-September 2024',
      },
      {
        text: 'Participation in Isomo Academy does not make students B2R Scholars, nor does it guarantee a university scholarship.',
      },
      {
        text: 'If you understand and are in agreement with these statements, we invite you to complete the following application.',
      },
      {
        text: 'The application period closes Monday, April 22, 2024, at 8:00pm.',
      },
      {
        text: 'Note: Please make sure your phone number and email address work well before starting this application.',
      },
    ],
  },
];
const Opportunity = ({
  chosenOpportunity,
  setChosenOpportunity,
  setNavigateToSection,
}) => {
  return (
    <div className="w-full h-fit">
      <div className="w-full px-6 lg:px-32 pb-12 pt-6">
        <div className="flex flex-col lg:flex-row items-start w-full gap-6">
          <div className="flex flex-col lg:w-2/3">
            {opportunityArray.map((opportunity) => {
              if (opportunity.id == chosenOpportunity) {
                return (
                  <div className="flex flex-col w-full">
                    <div className="bg-cover max-w-full overflow-hidden rounded-3xl max-h-[600px]">
                      <img
                        src={opportunity.image}
                        alt=""
                        className="object-cover"
                      />
                    </div>

                    <div className=" flex items-center gap-4 my-3">
                      <p className="text-fontGrey">
                        Published on {opportunity.date}
                      </p>
                    </div>

                    <h1 className="mt-1 font-bold text-2xl text-start">
                      {opportunity.title}
                    </h1>

                    <div className="mt-4 flex flex-col text-lg font-rubik text-fontGrey gap-4">
                      {opportunity.paragraphs.map((paragraph) => {
                        if (paragraph.linkObj) {
                          if (paragraph.linkObj.new_line) {
                            return (
                              <>
                                <p className="whitespace-pre-line">
                                  {paragraph.text}
                                </p>
                                <a
                                  href={paragraph.linkObj.link}
                                  target="_blank"
                                  className="font-medium text-primary underline w-fit"
                                >
                                  {paragraph.linkObj.link}
                                </a>
                              </>
                            );
                          } else {
                            return (
                              <div className="flex items-center flex-wrap gap-1 ">
                                <p className="whitespace-pre-line">
                                  {paragraph.text}
                                </p>
                                <a
                                  href={paragraph.linkObj.link}
                                  target="_blank"
                                  className="font-medium text-primary underline w-fit"
                                >
                                  {paragraph.linkObj.link}
                                </a>
                              </div>
                            );
                          }
                        } else {
                          return paragraph.header ? (
                            <p className="font-bold text-fontBlack">
                              {paragraph.header}
                            </p>
                          ) : paragraph.image ? (
                            <div
                              className={`bg-cover w-fit overflow-hidden rounded-2xl ${
                                paragraph.dimensions ? paragraph.dimensions : ''
                              }`}
                            >
                              <img
                                src={paragraph.image}
                                alt=""
                                className="w-full h-full object-scale-down"
                              />
                            </div>
                          ) : (
                            <p className="whitespace-pre-line">
                              {paragraph.text}
                            </p>
                          );
                        }
                      })}
                    </div>

                    {/* <div className="my-6 lg:my-12 flex gap-6 font-rubik">
                    <p className="text-lg">Share</p>
                    <div className="flex items-center gap-4">
                      <FaInstagram size={20} color="#01A653" />
                      <FaFacebook size={20} color="#01A653" />
                      <FaXTwitter size={20} color="#01A653" />
                    </div>
                  </div> */}
                  </div>
                );
              } else return null;
            })}
          </div>
          <div className="flex flex-col lg:w-1/3 bg-grey py-4 px-8 rounded-2xl font-rubik">
            <p className="text-lg font-semibold mb-4">Recent opportunities</p>
            <div className="flex flex-col gap-4">
              {opportunityArray.map((opportunity) => {
                return (
                  <div className="bg-white rounded-xl p-4 flex flex-col">
                    <div className=" flex items-center gap-4 my-3">
                      {opportunity.category && (
                        <p className="text-secondary">{opportunity.category}</p>
                      )}
                      <p className="text-fontGrey">
                        Published on {opportunity.date}
                      </p>
                    </div>
                    <p className="font-semibold mb-4">
                      {' '}
                      {opportunity.title.length > 40
                        ? opportunity.title.slice(0, 40) + '...'
                        : opportunity.title}
                    </p>
                    <p className="">
                      {opportunity.paragraphs[0].text.length > 80
                        ? opportunity.paragraphs[0].text.slice(0, 80) + '...'
                        : opportunity.paragraphs[0].text}
                    </p>

                    <div
                      className="mt-2 flex gap-2 items-center w-fit cursor-pointer"
                      onClick={() => {
                        setChosenOpportunity(opportunity.id);
                      }}
                    >
                      <p className="text-secondary font-rubik">Read more</p>
                      <LuMoveRight size={20} color="#FDB935" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Partners />
      <Footer setNavigateToSection={setNavigateToSection} />
    </div>
  );
};

export default Opportunity;
